"use strict";
/**
 * Shared product list for the origination picker modal. Lives in aven_types so
 * the UI, unit tests, and e2e tests all read from one source. Add a product
 * here and TypeScript will surface every consumer that needs updating.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORIGINATION_INTERSTITIAL_PRODUCT_ORDER = void 0;
exports.ORIGINATION_INTERSTITIAL_PRODUCT_ORDER = ['homeEquityCard', 'homeEquityCash', 'flexibleCash', 'rewardsCard', 'bitcoinCard', 'deposit'];
